<template>
    <div class="container h-full">
        <div class="overflow-hidden rounded-md">
            <div class="px-4 py-5 space-y-6 bg-white">
                <!-- title -->
                <div>
                    <div class="block text-sm font-medium text-gray-700">Title*</div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="form.title"
                            placeholder="Title"
                            :variant="errors('title') ? 'danger' : ''"
                        />
                        <div
                            v-if="errors('title')"
                            class="text-red-500"
                        >
                            {{ errors('title') }}
                        </div>
                    </div>
                </div>

                <div v-if="editData && editData.image_path">
                    <div class="block text-sm font-medium text-gray-700">Existing Image</div>
                    <img
                        class="object-cover w-full h-48"
                        :src="editData.image_path"
                        alt=""
                    />
                </div>

                <!-- image -->
                <div>
                    <div class="block text-sm font-medium text-gray-700">Images</div>
                    <FileUpload @filesUploaded="attachFilesToForm" />
                </div>
            </div>

            <div class="px-4 py-3 text-right bg-gray-50">
                <t-button
                    variant="success"
                    :disabled="processing"
                    size="sm"
                    @click="submitForm"
                >
                    {{ processing ? 'Saving...' : 'Save' }}
                </t-button>
            </div>
        </div>
    </div>
</template>

<script>
    import FileUpload from './FileUpload.vue';

    export default {
        name: 'FeaturedImageCreate',

        components: {
            FileUpload,
        },

        props: {
            editData: {
                type: Object,
                default: null,
            },
        },

        data() {
            return {
                form: {
                    title: null,
                    image: null,
                    processing: false,
                },
            };
        },

        async mounted() {
            if (this.editData) {
                this.form.title = this.editData.title;
            }
        },

        methods: {
            submitForm() {
                const payload = this.buildPayload();
                this.editData ? this.update(payload) : this.save(payload);
            },

            buildPayload() {
                const formData = new FormData();
                if (this.form.title) {
                    formData.append('title', this.form.title);
                }
                if (this.form.image) {
                    formData.append('image', this.form.image);
                }
                if (this.editData) {
                    formData.append('_method', 'PUT');
                }
                return formData;
            },

            save(payload) {
                this.processing = true;
                this.$inertia.post(route('featured.store'), payload, {
                    onSuccess: () => {
                        this.$emit('transactionComplete');
                    },
                    onFinish: () => {
                        this.processing = false;
                    },
                });
            },

            update(payload) {
                this.processing = true;
                this.$inertia.post(route('featured.update', this.editData.id), payload, {
                    onSuccess: () => {
                        this.$emit('transactionComplete');
                    },
                    onFinish: () => {
                        this.processing = false;
                    },
                });
            },

            attachFilesToForm(files) {
                this.form.image = files[0];
            },
        },
    };
</script>
